// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"8421837f","703":"68a83e42"}[chunkId] + ".chunk.js";
};